import { twMerge } from 'tailwind-merge';
import ToggleButtonGroup, {
  type ToggleButtonGroupProps,
} from '@mui/material/ToggleButtonGroup';
import { classes } from './utils';

export { default as ToggleOption } from './ToggleOption';

export type ToggleBlockProps<T> = Omit<ToggleButtonGroupProps, 'onChange'> & {
  className?: string;
  exclusive?: boolean;
  vertical?: boolean;
  onChange: (value: T) => void;
};

export default function ToggleBlock<T>({
  className,
  exclusive = true,
  vertical = false,
  onChange,
  ...props
}: ToggleBlockProps<T>) {
  const handleChange = (e: any, value: T | null) => {
    if (value === null) return; // Selecting the current value
    return onChange(value);
  };

  return (
    <ToggleButtonGroup
      exclusive={exclusive}
      className={twMerge(classes.wrapper, className)}
      orientation={vertical ? 'vertical' : 'horizontal'}
      onChange={handleChange}
      {...props}
    />
  );
}
